import { readCollectionContext, caseSupportsBrand } from './gc-collection-context.js?v=gc-brand-20261103';
import { comparePhoneModels } from './gc-phone-model-order.js?v=gc-inline19';

(function () {
  'use strict';

  var LS_MODEL = 'gc_selected_phone_model';
  var LS_BRAND = 'gc_selected_phone_brand';
  var activeChooser = null;

  function squash(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function modelKey(s) {
    if (typeof window.gcNormalizePhoneModelKey === 'function') {
      try { var k = window.gcNormalizePhoneModelKey(s); if (k) return String(k); } catch (e) {}
    }
    return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }
  function brandOf(s) {
    if (typeof window.gcGetPhoneModelBrand === 'function') {
      try { var b = window.gcGetPhoneModelBrand(s); if (b) return String(b).toLowerCase(); } catch (e) {}
    }
    if (/^\s*iphone/i.test(s)) return 'iphone';
    if (/samsung|galaxy/i.test(s)) return 'samsung';
    return 'other';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function el(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstElementChild; }

  var CASE_ALIASES = Object.freeze({tough:'tough',tough_case:'tough','tough-magsafe':'tough-magsafe',tough_magsafe_case:'tough-magsafe','tough-magnetic':'tough-magnetic',tough_magnetic_case:'tough-magnetic','clear-magsafe':'clear-magsafe',clear_magsafe_case:'clear-magsafe','frosted-clear':'frosted-clear',frosted_clear_case:'frosted-clear',biodegradable:'biodegradable',biodegradable_case:'biodegradable'});
  var STYLE_ALIASES = Object.freeze({cute:'cute','style-cute':'cute',floral:'floral','style-floral':'floral',abstract:'abstract','style-abstract':'abstract',minimal:'minimal','style-minimal':'minimal',celestial:'celestial','style-celestial':'celestial',coquette:'coquette','style-coquette':'coquette'});
  function canonicalCase(value) { return Object.prototype.hasOwnProperty.call(CASE_ALIASES, value) ? CASE_ALIASES[value] : null; }
  function canonicalStyle(value) { return Object.prototype.hasOwnProperty.call(STYLE_ALIASES, value) ? STYLE_ALIASES[value] : null; }
  function completeModels(cfg) {
    return cfg.modelsComplete === true && Number.isSafeInteger(cfg.modelsExpected) && cfg.modelsExpected > 0 &&
      cfg.modelsEmitted === cfg.modelsExpected && Array.isArray(cfg.models) && cfg.models.length === cfg.modelsExpected &&
      cfg.models.every(function (m) { return m && typeof m.value === 'string' && m.value.trim() && typeof m.label === 'string' && m.label.trim(); }) &&
      new Set(cfg.models.map(function (m) { return m.value; })).size === cfg.modelsExpected;
  }
  function Redesign(root) {
    this.root = root;
    this.cfg = JSON.parse(root.querySelector('[data-gc-cr-config]').textContent);
    this.pageContext = readCollectionContext(this.cfg.collectionHandle || 'all', new URL(window.location.href), this.cfg.pathTags || []);
    if (this.pageContext.brand) this.cfg.brand = this.pageContext.brand;
    if (this.pageContext.lockedStyle) this.cfg.lockedStyle = this.pageContext.lockedStyle;
    this.cfg.caseTypes = this.cfg.caseTypes.map(function (x) { return { key: canonicalCase(x.key), label: x.label }; });
    this.cfg.caseTypes = this.cfg.caseTypes.filter(function (c) { return caseSupportsBrand(c.key, this.pageContext.brand); }, this);
    this.cfg.styles = this.cfg.styles.map(function (x) { return { tag: canonicalStyle(x.tag), label: x.label }; });
    this.invalidContext = this.pageContext.invalid || (!!this.cfg.lockedStyle && !canonicalStyle(this.cfg.lockedStyle));
    this.cfg.lockedStyle = this.cfg.lockedStyle ? canonicalStyle(this.cfg.lockedStyle) : null;
    this.uid = root.getAttribute('data-section-id') || 'gc';
    this.heading = root.querySelector('.gc-cr__title');
    this.defaultHeading = this.heading ? this.heading.textContent : 'Find your next favourite case';
    this.caseLabel = {}; this.caseOrder = {};
    var self = this;
    this.cfg.caseTypes.forEach(function (c, i) { self.caseLabel[c.key] = c.label; self.caseOrder[c.key] = i; });
    this.styleLabel = {};
    this.cfg.styles.forEach(function (s) { self.styleLabel[s.tag] = s.label; });
    this.money = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.cfg.currency || 'USD' });
    this.pageRequest = null; this.pageData = null; this.seenDesigns = new Set();
    this.initialPage = null;
    try { this.initialPage = JSON.parse(root.querySelector('[data-gc-cr-page]')?.textContent || 'null'); } catch (error) {}
    this.state = { model: '', caseKey: '', styles: [], sort: this.cfg.defaultSort, shown: this.cfg.perPage || 24 };
    this.phoneBrand = this.pageContext.brand || '';
    this.q = function (sel) { return root.querySelector(sel); };
    this.els = {
      current: this.q('[data-gc-cr-phone-current]'), modelName: this.q('[data-gc-cr-model-name]'),
      change: this.q('[data-gc-cr-change-phone]'), combo: this.q('[data-gc-cr-combo]'),
      input: this.q('[data-gc-cr-input]'), list: this.q('[data-gc-cr-listbox]'),
      cancel: this.q('[data-gc-cr-cancel]'), comboStatus: this.q('[data-gc-cr-combo-status]'),
      caseChips: this.q('[data-gc-cr-case-chips]'), styleChips: this.q('[data-gc-cr-style-chips]'),
      styleRow: this.q('[data-gc-cr-style-row]'),
      brands: this.q('[data-gc-cr-brands]'), activeFilters: this.q('[data-gc-cr-active]'),
      count: this.q('[data-gc-cr-count]'), toolbar: this.q('.gc-cr__toolbar'), grid: this.q('[data-gc-cr-grid]'),
      empty: this.q('[data-gc-cr-empty]'), more: this.q('[data-gc-cr-more]'), moreStatus: this.q('[data-gc-cr-more-status]'),
      context: this.q('[data-gc-cr-context]'), contextList: this.q('[data-gc-cr-context-list]'),
      clear: this.q('[data-gc-cr-clear]'), hint: this.q('[data-gc-cr-phone-hint]')
    };
    this.modelsReady = completeModels(this.cfg);
    if (this.invalidContext) { this.models = []; this.rejectSavedFilters(); return; }
    if (!this.modelsReady || this.invalidContext) {
      this.models = []; this.els.input.disabled = true;
      this.els.grid.setAttribute('aria-busy', 'false'); this.els.count.textContent = '';
      this.els.comboStatus.textContent = this.invalidContext ? 'This collection context is unavailable. Please try another collection.' : 'The complete phone list is unavailable. Please reload to try again.';
      return;
    }
    if (this.cfg.lockedStyle && !this.styleLabel[this.cfg.lockedStyle]) this.styleLabel[this.cfg.lockedStyle] = this.cfg.lockedStyle.replace(/^style-/, '');
    if (this.cfg.lockedStyle) this.els.styleRow.hidden = true;
    var onlyBrand = this.cfg.brand && this.cfg.brand !== 'all' ? this.cfg.brand : '';
    this.renderContext(onlyBrand);
    this.models = this.cfg.models.map(function (m, i) {
      return { label: m.label, value: m.value, brand: brandOf(m.label), key: modelKey(m.label), sq: squash(m.label), i: i };
    }).filter(function (m) { return !onlyBrand || m.brand === onlyBrand; }).sort(comparePhoneModels);
    this.bindCombo();
    this.bindControls();
    this.readUrl(true);
    var me = this;
    window.addEventListener('popstate', function () { me.readUrl(false); });
    document.addEventListener('gc:saved-phone-change', function(event){
      if(!me.root.isConnected)return;
      var url=new URL(window.location.href), model=event.detail?.model || '';
      ['model',me.cfg.sizeParam,'device','page'].forEach(function(k){url.searchParams.delete(k);});
      if(model){url.searchParams.set('model',model);url.searchParams.set(me.cfg.sizeParam,model);}
      history.pushState({gcCr:true},'',url.pathname+url.search+url.hash);
      me.readUrl(false);
    });
  }

  /* ---------- Page context (brand / locked style): fixed labels, never clearable ---------- */
  Redesign.prototype.renderContext = function (onlyBrand) {
    var items = [];
    var brandName = { iphone: 'iPhone cases', samsung: 'Samsung Galaxy cases' }[onlyBrand];
    if (brandName) items.push(['brand', onlyBrand, brandName]);
    if (this.cfg.lockedStyle) items.push(['style', this.cfg.lockedStyle, 'Style: ' + this.styleLabel[this.cfg.lockedStyle]]);
    if (this.cfg.scopePath && !onlyBrand && !this.cfg.lockedStyle) items.push(['collection', this.cfg.collectionHandle, this.defaultHeading]);
    if (this.pageContext.lockedCase) items.push(['case', this.pageContext.lockedCase, this.caseLabel[this.pageContext.lockedCase]]);
    this.context = items;
    if (!this.els.context) return;
    this.els.context.hidden = !items.length;
    this.els.contextList.innerHTML = items.map(function (it) {
      return '<li class="gc-cr__context-tag" data-gc-cr-context-item="' + esc(it[0]) + '" data-value="' + esc(it[1]) + '">' + esc(it[2]) + '</li>';
    }).join('');
  };

  Redesign.prototype.findModel = function (v) {
    if (!v) return null;
    var k = modelKey(v), sq = squash(v);
    return this.models.find(function (m) { return m.key === k || squash(m.value) === sq || m.sq === sq; }) || null;
  };

  /* ---------- URL / storage state ---------- */
  Redesign.prototype.readUrl = function (initial) {
    var currentUrl = new URL(window.location.href), p = currentUrl.searchParams;
    var tagPath = this.cfg.collectionPath && currentUrl.pathname.startsWith(this.cfg.collectionPath + '/') ? currentUrl.pathname.slice(this.cfg.collectionPath.length + 1) : '';
    var pathTags;
    try { pathTags = tagPath ? decodeURIComponent(tagPath).split('+') : []; }
    catch { this.rejectSavedFilters(); return; }
    var routeContext = readCollectionContext(this.cfg.collectionHandle || 'all', currentUrl, pathTags);
    if (routeContext.invalid) { this.rejectSavedFilters(); return; }
    if (routeContext.lockedCase && p.has('case') && canonicalCase(p.get('case')) !== routeContext.lockedCase) { this.rejectSavedFilters(); return; }
    this.els.change.disabled = false;
    this.els.brands.querySelectorAll('button').forEach(function (button) { button.disabled = false; });
    this.pageContext.legacyCase = routeContext.legacyCase; this.pageContext.legacyStyles = routeContext.legacyStyles;
    var raw = p.get('model') || p.get(this.cfg.sizeParam) || '';
    var m = this.findModel(raw);
    var fromStorage = false;
    if (!raw && initial) {
      try { var stored = window.localStorage.getItem(LS_MODEL) || ''; m = this.findModel(stored); fromStorage = !!m; } catch (e) {}
    }
    this.state.model = m ? m.value : '';
    this.state.modelLabel = m ? m.label : '';
    this.state.unknownModel = raw && !m ? raw : '';
    this.state.brandConflict = !!raw && !m && this.cfg.brand && this.cfg.brand !== 'all' && brandOf(raw) !== this.cfg.brand;
    var c = canonicalCase(p.get('case') || this.pageContext.legacyCase || '') || '';
    if (this.pageContext.lockedCase) c = this.pageContext.lockedCase;
    this.state.caseKey = this.caseLabel[c] ? c : '';
    var me = this;
    this.state.styles = (p.has('style') ? p.get('style') : this.pageContext.legacyStyles.join(',')).split(',').map(function (s) { return canonicalStyle(s.trim().toLowerCase()); })
      .filter(function (s) { return me.styleLabel[s] && (!me.cfg.lockedStyle || me.pageContext.lockedStyle); });
    this.state.sort = this.cfg.defaultSort;
    this.state.shown = this.cfg.perPage || 24;
    var serverTags = this.state.styles.map(function (style) { return 'style-'+style; });
    if (this.state.caseKey && !this.pageContext.lockedCase) serverTags.push('case-'+this.state.caseKey);
    var serverUrlNeedsSync = p.get(this.cfg.sizeParam) !== (this.state.model || null) ||
      (this.cfg.collectionHandle === 'all' ? p.get('sort_by') !== this.state.sort : p.has('sort_by')) || JSON.stringify(p.getAll('filter.p.tag').sort()) !== JSON.stringify(serverTags.sort());
    if (fromStorage || serverUrlNeedsSync || (p.has('case') && p.get('case') !== this.state.caseKey) || (p.has('style') && p.get('style') !== this.state.styles.join(','))) this.writeUrl(true);
    this.renderPhone();
    this.load();
  };

  Redesign.prototype.writeUrl = function (replace) {
    var u = new URL(window.location.href), s = this.state;
    ['model', this.cfg.sizeParam, 'case', 'style', 'sort_by', 'page'].forEach(function (k) { u.searchParams.delete(k); });
    u.searchParams.delete('filter.p.tag');
    if (this.cfg.collectionHandle === 'all') u.searchParams.set('sort_by', s.sort);
    if (this.cfg.pathTags?.length) u.pathname = this.cfg.collectionPath;
    this.pageContext.legacyCase = ''; this.pageContext.legacyStyles = [];
    if (s.model) { u.searchParams.set(this.cfg.sizeParam, s.model); u.searchParams.set('model', s.model); }
    if (s.caseKey && !this.pageContext.lockedCase) { u.searchParams.set('case', s.caseKey); u.searchParams.append('filter.p.tag','case-'+s.caseKey); }
    if (s.styles.length) { u.searchParams.set('style', s.styles.join(',')); s.styles.forEach(function (style) { u.searchParams.append('filter.p.tag','style-'+style); }); }
    history[replace ? 'replaceState' : 'pushState']({ gcCr: true }, '', u.pathname + u.search + u.hash);
  };

  Redesign.prototype.rejectSavedFilters = function () {
    this.closeChoosers(null);
    this.loadToken = {}; this.pageRequest?.abort(); clearTimeout(this.loadingNoticeTimer);
    this.index = null; this.families = null; this.setLoading(false);
    this.els.grid.innerHTML = ''; this.els.caseChips.innerHTML = ''; this.els.styleChips.innerHTML = '';
    this.els.activeFilters.innerHTML = ''; this.els.activeFilters.hidden = true;
    this.els.clear.hidden = true; this.els.more.hidden = true; this.els.moreStatus.textContent = '';
    this.els.count.textContent = 'These filters conflict with this collection or are not supported here.';
    this.els.toolbar.hidden = false;
    this.els.change.disabled = true; this.els.input.disabled = true;
    this.els.brands.querySelectorAll('button').forEach(function (button) { button.disabled = true; });
    var reset = new URL(window.location.href);
    reset.pathname = this.cfg.collectionPath;
    Array.from(reset.searchParams.keys()).forEach(function (key) {
      if (['case', 'style', 'page'].includes(key) || (key.startsWith('filter.') && key !== 'filter.v.option.size')) reset.searchParams.delete(key);
    });
    this.els.empty.hidden = false;
    this.els.empty.innerHTML = '<p>The saved conditions have not been applied. Clear them to browse this collection.</p><a class="gc-cr__btn gc-cr__btn--ghost" href="' + esc(reset.pathname + reset.search + reset.hash) + '">Clear conflicting filters</a>';
  };

  Redesign.prototype.setModel = function (m) {
    this.state.model = m.value; this.state.modelLabel = m.label; this.state.unknownModel = ''; this.state.brandConflict = false;
    this.state.shown = this.cfg.perPage || 24;
    try { window.localStorage.setItem(LS_MODEL, m.value); window.localStorage.setItem(LS_BRAND, m.brand); } catch (e) {}
    this.writeUrl(false);
    this.renderPhone();
    this.els.change.focus();
    this.load();
    this.root.dispatchEvent(new CustomEvent('gc:phone-model-change', { bubbles: true, detail: { model: m.value, brand: m.brand } }));
  };

  /* ---------- Combobox (single model control) ---------- */
  Redesign.prototype.renderBrands = function () {
    var me = this, locked = this.cfg.brand && this.cfg.brand !== 'all' ? this.cfg.brand : '';
    this.els.brands.hidden = !!locked;
    this.els.combo.classList.toggle('gc-cr__combo--locked', !!locked);
    this.els.brands.querySelectorAll('[data-gc-cr-brand]').forEach(function (b) {
      b.hidden = !!locked && b.dataset.gcCrBrand !== locked;
      b.setAttribute('aria-pressed', String(b.dataset.gcCrBrand === me.phoneBrand));
    });
    this.els.input.disabled = !this.phoneBrand;
    this.els.input.placeholder = this.phoneBrand ? 'Search your ' + (this.phoneBrand === 'iphone' ? 'iPhone' : 'Samsung') + ' model' : 'Choose your phone brand first';
  };

  Redesign.prototype.renderPhone = function () {
    var has = !!this.state.model;
    if (this.heading) this.heading.textContent = has && !this.cfg.scopePath ? 'Cases for ' + this.state.modelLabel : this.defaultHeading;
    this.phoneBrand = this.state.model ? brandOf(this.state.model) : (this.pageContext.brand || this.phoneBrand);
    this.renderBrands();
    this.els.current.hidden = !has;
    this.els.combo.hidden = has;
    this.els.cancel.hidden = true;
    this.els.modelName.textContent = this.state.modelLabel || '';
    if (this.els.hint) this.els.hint.hidden = has;
    this.els.input.value = '';
    this.closeList();
    this.updateLowerModules();
    this.els.comboStatus.textContent = this.state.brandConflict
      ? 'This page is for ' + (this.cfg.brand === 'samsung' ? 'Samsung Galaxy' : 'iPhone') + ' cases. Choose a matching phone to continue.'
      : this.state.unknownModel
      ? '“' + this.state.unknownModel + '” is not one of our phone models. Search below.' : '';
  };

  Redesign.prototype.matches = function (query) {
    var tokens = String(query || '').toLowerCase().split(/\s+/).map(squash).filter(Boolean);
    var whole = squash(query);
    var brand = this.phoneBrand;
    return this.models.filter(function (m) {
      if (!brand || m.brand !== brand) return false;
      if (!tokens.length) return true;
      if (m.sq.indexOf(whole) !== -1) return true;
      return tokens.every(function (t) { return m.sq.indexOf(t) !== -1; });
    });
  };

  Redesign.prototype.openList = function () {
    if (this._blurTimer) { clearTimeout(this._blurTimer); this._blurTimer = null; }
    if (!this.phoneBrand) { this.closeList(); this.els.comboStatus.textContent = 'Choose iPhone or Samsung first.'; return; }
    var q = this.els.input.value, list = this.els.list, me = this;
    var found = this.matches(q);
    this.active = -1;
    list.innerHTML = '';
    if (!found.length) {
      this.closeList();
      this.els.comboStatus.textContent = 'No phone model matches “' + q.trim() + '”. GoCraftly cases are made for iPhone and Samsung Galaxy models.';
      this.els.combo.classList.add('is-nomatch');
      return;
    }
    this.els.combo.classList.remove('is-nomatch');
    this.els.comboStatus.textContent = q.trim() ? found.length + ' phone model' + (found.length === 1 ? '' : 's') + ' found.' : '';
    var groups = [['iphone', 'iPhone'], ['samsung', 'Samsung Galaxy'], ['other', 'Other']];
    this.optionEls = [];
    groups.forEach(function (g) {
      var items = found.filter(function (m) { return m.brand === g[0]; });
      if (!items.length) return;
      var grp = el('<div role="group" class="gc-cr__opt-group" aria-label="' + esc(g[1]) + '"><div class="gc-cr__opt-head" aria-hidden="true">' + esc(g[1]) + '</div></div>');
      items.forEach(function (m) {
        var id = 'GcCrOpt-' + me.uid + '-' + m.i;
        var o = el('<div role="option" class="gc-cr__opt" id="' + id + '" aria-selected="' + (m.value === me.state.model) + '">' + esc(m.label) + '</div>');
        o.addEventListener('mousedown', function (e) { e.preventDefault(); });
        o.addEventListener('click', function () { me.setModel(m); });
        o._model = m;
        grp.appendChild(o); me.optionEls.push(o);
      });
      list.appendChild(grp);
    });
    list.hidden = false;
    this.els.input.setAttribute('aria-expanded', 'true');
    if (q.trim()) this.setActive(0);
  };
  Redesign.prototype.closeList = function () {
    this.els.list.hidden = true; this.els.input.setAttribute('aria-expanded', 'false');
    this.els.input.removeAttribute('aria-activedescendant'); this.active = -1;
  };
  Redesign.prototype.setActive = function (i) {
    if (!this.optionEls || !this.optionEls.length) return;
    i = Math.max(0, Math.min(this.optionEls.length - 1, i));
    this.optionEls.forEach(function (o, j) { o.classList.toggle('is-active', j === i); });
    this.active = i;
    var o = this.optionEls[i];
    this.els.input.setAttribute('aria-activedescendant', o.id);
    var listRect = this.els.list.getBoundingClientRect(), optionRect = o.getBoundingClientRect();
    if (optionRect.top < listRect.top) this.els.list.scrollTop += optionRect.top - listRect.top;
    else if (optionRect.bottom > listRect.bottom) this.els.list.scrollTop += optionRect.bottom - listRect.bottom;
  };
  Redesign.prototype.focusCombo = function () {
    this.els.current.hidden = true; this.els.combo.hidden = false;
    this.els.cancel.hidden = !this.state.model;
    this.els.input.value = '';
    if (this.phoneBrand) this.els.input.focus({ preventScroll: true });
    else this.els.brands.querySelector('button:not([hidden])')?.focus({ preventScroll: true });
    this.openList();
  };
  Redesign.prototype.bindCombo = function () {
    var me = this, input = this.els.input;
    this.els.brands.addEventListener('click', function (e) {
      var button = e.target.closest('[data-gc-cr-brand]');
      if (!button || button.hidden) return;
      me.phoneBrand = button.dataset.gcCrBrand; me.renderBrands(); input.value = '';
      input.focus({ preventScroll: true }); me.openList();
    });
    input.addEventListener('input', function () { me.openList(); });
    input.addEventListener('focus', function () { me.openList(); });
    input.addEventListener('blur', function () { me._blurTimer = setTimeout(function () { me._blurTimer = null; me.closeList(); }, 120); });
    input.addEventListener('keydown', function (e) {
      var open = !me.els.list.hidden;
      if (e.key === 'ArrowDown') { e.preventDefault(); if (!open) me.openList(); me.setActive(me.active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (!open) { me.openList(); me.setActive(me.optionEls.length - 1); } else me.setActive(me.active < 0 ? me.optionEls.length - 1 : me.active - 1); }
      else if (e.key === 'Home' && open) { e.preventDefault(); me.setActive(0); }
      else if (e.key === 'End' && open) { e.preventDefault(); me.setActive(me.optionEls.length - 1); }
      else if (e.key === 'Enter') {
        e.preventDefault();
        if (open && me.active >= 0) me.setModel(me.optionEls[me.active]._model);
        else { var f = me.matches(input.value); if (f.length === 1) me.setModel(f[0]); }
      } else if (e.key === 'Escape') {
        if (open) me.closeList(); else if (me.state.model) { me.renderPhone(); me.els.change.focus(); }
      }
    });
    this.els.change.addEventListener('click', function () { me.focusCombo(); });
    this.els.cancel.addEventListener('click', function () { me.renderPhone(); me.els.change.focus(); });
  };

  /* ---------- Refinement controls ---------- */
  Redesign.prototype.bindControls = function () {
    var me = this;
    this.els.more.addEventListener('click', function () {
      me.state.shown += me.cfg.perPage || 24; me.render(true);
    });
    this.root.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-gc-cr-remove]');
      if (remove) {
        if (remove.dataset.gcCrRemove === 'case') me.state.caseKey = me.pageContext.lockedCase || '';
        else me.state.styles = me.state.styles.filter(function (v) { return v !== remove.dataset.value; });
        me.state.shown = me.cfg.perPage || 24; me.writeUrl(true); me.render();
        (me.els.activeFilters.querySelector('button') || me.els.caseChips.querySelector('button') || me.els.change).focus({preventScroll:true}); return;
      }
      if (me.loading && e.target.closest('[data-gc-cr-chip], [data-gc-cr-more]')) return;
      var chip = e.target.closest('[data-gc-cr-chip]');
      if (chip && me.root.contains(chip)) {
        var kind = chip.getAttribute('data-gc-cr-chip'), v = chip.getAttribute('data-value');
        if (kind === 'case' && !me.pageContext.lockedCase) me.state.caseKey = (v === me.state.caseKey ? '' : v);
        if (kind === 'style') {
          if (!v) me.state.styles = [];
          else if (me.state.styles.indexOf(v) === -1) me.state.styles = me.state.styles.concat(v);
          else me.state.styles = me.state.styles.filter(function (s) { return s !== v; });
        }
        me.lastChip = {kind:kind, value:v};
        me.state.shown = me.cfg.perPage || 24; me.writeUrl(true); me.render(); return;
      }
      var act = e.target.closest('[data-gc-cr-action]');
      if (act) {
        var a = act.getAttribute('data-gc-cr-action');
        if (a === 'clear-phone') me.clearPhone();
        else if (a === 'clear-case') { me.state.caseKey = me.pageContext.lockedCase || ''; me.state.shown = me.cfg.perPage || 24; me.writeUrl(true); me.renderWithRecoveryFocus(act); }
        else if (a === 'clear-all') me.clearFilters(act);
        else if (a === 'change-phone') me.focusCombo();
        else if (a === 'retry') me.retryLoad();
        else if (a === 'retry-next') me.loadNext();
        return;
      }
      var toggle = e.target.closest('[data-gc-cr-choose]');
      if (toggle) {
        var card = toggle.closest('.gc-cr-card');
        if (!me.state.model) { me.focusCombo(); return; }
        if (me.chooser?.button === toggle) me.closeChoosers(null, true);
        else me.openChooser(card, toggle);
        return;
      }
      if (!e.target.closest('.gc-cr-card')) me.closeChoosers(null);
    });
  };
  Redesign.prototype.renderWithRecoveryFocus = function (trigger) {
    var me = this, requested = document.activeElement === trigger, moved = false;
    var listeners = new AbortController();
    document.addEventListener('focusin', function (event) {
      if (event.target !== trigger && event.target !== document.body && event.target !== document.documentElement) moved = true;
    }, {signal:listeners.signal});
    document.addEventListener('pointerdown', function () { moved = true; }, {signal:listeners.signal});
    document.addEventListener('keydown', function (event) { if (event.key === 'Tab') moved = true; }, {signal:listeners.signal});
    var pending = this.render(), token = this.loadToken;
    return Promise.resolve(pending).finally(function () {
      listeners.abort();
      if (!requested || moved || me.loadToken !== token || !me.root.isConnected) return;
      var active = document.activeElement;
      if (active !== trigger && active !== document.body && active !== document.documentElement) return;
      var retry = !me.els.empty.hidden && me.els.empty.querySelector('[data-gc-cr-action="retry"]');
      var chip = me.els.caseChips.querySelector('button:not(:disabled)');
      var target = retry || (chip?.getClientRects().length ? chip : me.els.change);
      if (target && !target.disabled && target.getClientRects().length) target.focus({preventScroll:true});
    });
  };
  Redesign.prototype.clearPhone = function () {
    this.state.model = ''; this.state.modelLabel = ''; this.state.unknownModel = ''; this.state.brandConflict = false; this.state.shown = this.cfg.perPage || 24;
    try { window.localStorage.removeItem(LS_MODEL); window.localStorage.removeItem(LS_BRAND); } catch (e) {}
    this.writeUrl(true); this.renderPhone(); this.load();
  };
  Redesign.prototype.clearFilters = function (trigger) {
    this.state.caseKey = this.pageContext.lockedCase || ''; this.state.styles = []; this.state.shown = this.cfg.perPage || 24;
    this.writeUrl(true); this.renderWithRecoveryFocus(trigger || document.activeElement);
  };
  Redesign.prototype.closeChoosers = function (except, restoreFocus) {
    var current = this.chooser;
    if (!current || current.card === except) return;
    this.chooser = null;
    if (activeChooser === this) activeChooser = null;
    current.cleanup();
    try { if (current.menu.matches(':popover-open')) current.menu.hidePopover(); } catch (error) {}
    current.menu.hidden = true;
    current.menu.removeAttribute('popover'); current.menu.removeAttribute('data-placement');
    current.menu.classList.remove('gc-cr-popover');
    if (current.style === null) current.menu.removeAttribute('style'); else current.menu.setAttribute('style',current.style);
    if (current.parent.isConnected) current.parent.insertBefore(current.menu,current.next?.parentNode === current.parent ? current.next : null);
    else current.menu.remove();
    current.card.classList.remove('is-choosing'); current.button.setAttribute('aria-expanded','false');
    if (restoreFocus && current.button.isConnected) current.button.focus({preventScroll:true});
  };

  Redesign.prototype.positionChooser = function () {
    var current = this.chooser;
    if (!current) return;
    var button = current.button, menu = current.menu, rect = button.getBoundingClientRect(), viewport = window.visualViewport;
    var left = (viewport?.offsetLeft || 0)+8, right = (viewport?.offsetLeft || 0)+(viewport?.width || document.documentElement.clientWidth)-8;
    var top = (viewport?.offsetTop || 0)+8, bottom = (viewport?.offsetTop || 0)+(viewport?.height || window.innerHeight)-8;
    document.querySelectorAll('#header-group,header.header-section,header-component').forEach(function (node) {
      var box=node.getBoundingClientRect(); if (box.height && box.top <= top && box.bottom > top) top=box.bottom+8;
    });
    document.querySelectorAll('#preview-bar-iframe,#shopify-preview-bar-iframe,[data-shopify-preview-bar]').forEach(function (node) {
      var box=node.getBoundingClientRect(); if (box.height && box.bottom >= bottom && box.top < bottom) bottom=box.top-8;
    });
    if (!button.isConnected || rect.bottom <= top || rect.top >= bottom || rect.right <= left || rect.left >= right || right-left < 100) { this.closeChoosers(null); return; }
    var width=Math.min(Math.max(rect.width,320),right-left), scrollTop=menu.scrollTop;
    menu.style.width=width+'px'; menu.style.maxHeight='none';
    menu.style.setProperty('--gc-cr-price-width','auto');
    var priceWidth=0;
    menu.querySelectorAll('.gc-cr-card__option-price').forEach(function (price) { priceWidth=Math.max(priceWidth,Math.ceil(price.getBoundingClientRect().width)); });
    menu.style.setProperty('--gc-cr-price-width',priceWidth+'px');
    var natural=menu.getBoundingClientRect().height, below=Math.max(0,bottom-rect.bottom-6), above=Math.max(0,rect.top-top-6);
    var down=below >= natural || below >= above, space=down?below:above;
    if (space < 44) { this.closeChoosers(null); return; }
    menu.style.maxHeight=Math.floor(space)+'px';
    var height=menu.getBoundingClientRect().height;
    menu.style.left=Math.max(left,Math.min(rect.left,right-width))+'px';
    menu.style.top=(down?rect.bottom+6:rect.top-6-height)+'px';
    menu.dataset.placement=down?'bottom':'top'; menu.style.visibility='visible';menu.scrollTop=scrollTop;
  };

  Redesign.prototype.openChooser = function (card, button) {
    if (activeChooser) activeChooser.closeChoosers(null);
    var menu=card.querySelector('.gc-cr-card__options'); if (!menu) return;
    var me=this, frame=0, current={card:card,button:button,menu:menu,parent:menu.parentNode,next:menu.nextSibling,style:menu.getAttribute('style')};
    this.chooser=current; activeChooser=this;
    var computed=getComputedStyle(this.root), inheritedFont=getComputedStyle(menu).fontFamily;
    ['--gc-cr-accent','--gc-cr-accent-tint','--gc-cr-ink','--gc-cr-line','--gc-cr-ui'].forEach(function (key) { menu.style.setProperty(key,computed.getPropertyValue(key)); });
    menu.style.fontFamily=inheritedFont;
    menu.style.visibility='hidden'; menu.classList.add('gc-cr-popover'); menu.hidden=false;
    document.body.appendChild(menu);
    if (typeof menu.showPopover === 'function') { menu.setAttribute('popover','manual'); try { menu.showPopover(); } catch (error) { menu.removeAttribute('popover'); } }
    card.classList.add('is-choosing'); button.setAttribute('aria-expanded','true');
    var outside=function(e){if(!menu.contains(e.target)&&!button.contains(e.target))me.closeChoosers(null);};
    var schedule=function(e){if(e?.target instanceof Node && menu.contains(e.target))return;if(!frame)frame=requestAnimationFrame(function(){frame=0;me.positionChooser();});};
    var click=function(e){if(e.target.closest('a[href]'))me.closeChoosers(null);};
    var keydown=function(e){
      if(e.key==='Escape'){e.preventDefault();me.closeChoosers(null,true);return;}
      if(e.key!=='Tab'||!menu.contains(document.activeElement))return;
      var links=Array.from(menu.querySelectorAll('a[href]'));
      if(e.shiftKey&&document.activeElement===links[0]){e.preventDefault();me.closeChoosers(null,true);}
      else if(!e.shiftKey&&document.activeElement===links[links.length-1]){
        var focusable=Array.from(document.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')).filter(function(node){return node.tabIndex>=0&&!node.disabled&&!menu.contains(node)&&node.getClientRects().length&&getComputedStyle(node).visibility!=='hidden';});
        var next=focusable[focusable.indexOf(button)+1];
        e.preventDefault();me.closeChoosers(null);(next||button).focus();
      }
    };
    document.addEventListener('pointerdown',outside,true); document.addEventListener('focusin',outside,true); document.addEventListener('keydown',keydown,true);
    window.addEventListener('scroll',schedule,{capture:true,passive:true});window.addEventListener('resize',schedule,{passive:true});
    window.visualViewport?.addEventListener('resize',schedule);window.visualViewport?.addEventListener('scroll',schedule);
    menu.addEventListener('click',click);
    current.cleanup=function(){
      cancelAnimationFrame(frame);document.removeEventListener('pointerdown',outside,true);document.removeEventListener('focusin',outside,true);document.removeEventListener('keydown',keydown,true);
      window.removeEventListener('scroll',schedule,true);window.removeEventListener('resize',schedule);window.visualViewport?.removeEventListener('resize',schedule);window.visualViewport?.removeEventListener('scroll',schedule);menu.removeEventListener('click',click);
    };
    document.fonts?.ready.then(function(){if(me.chooser===current)schedule();});
    this.positionChooser();
    if(this.chooser){var first=menu.querySelector('a[href]');if(first)first.focus({preventScroll:true});}
  };

  Redesign.prototype.requestState = function () {
    return {model:this.state.model || '',caseKey:this.state.caseKey || '',styles:this.state.styles.slice().sort(),sort:this.state.sort};
  };
  Redesign.prototype.setLoading = function (loading) {
    this.loading = loading;
    if (loading) this.els.toolbar.hidden = false;
    this.els.more.disabled = loading;
    this.root.querySelectorAll('[data-gc-cr-chip]').forEach(function (b) { b.disabled = loading; });
    this.els.grid.setAttribute('aria-busy',String(loading));
  };
  Redesign.prototype.validateBatch = function (batch, page, state, html) {
    var ensure = function (ok, message) { if (!ok) throw new Error(message); };
    ensure(batch?.version === 'gc-paged-2' && batch.complete === true && batch.error === null,'The server could not verify this page.');
    ensure(batch.collection === this.cfg.collectionHandle && batch.model === state.model && batch.case === state.caseKey && JSON.stringify((batch.styles || []).slice().sort()) === JSON.stringify(state.styles),'Page filters changed.');
    ensure(batch.requiredStyle === (this.cfg.lockedStyle || '') && typeof state.sort === 'string' && state.sort.length > 0 && batch.defaultSort === state.sort && batch.sort === state.sort && batch.sourceSort === state.sort,'The requested sort is not verified.');
    var context = this.cfg.catalogContext;
    ensure(batch.currency === context.currency && batch.country === context.market && batch.locale === context.locale,'Page currency or market changed.');
    ensure(Number.isSafeInteger(batch.rawTotal) && batch.rawTotal >= 0 && [24,96,100,144].includes(batch.pageSize) && batch.pages === Math.max(1,Math.ceil(batch.rawTotal/batch.pageSize)) && batch.page === page && page <= batch.pages,'Invalid page cursor.');
    ensure(batch.rawRows === Math.min(batch.pageSize,Math.max(0,batch.rawTotal-(page-1)*batch.pageSize)) && batch.nextPage === (page < batch.pages ? page+1 : null),'Incomplete page cursor.');
    var template = document.createElement('template'); template.innerHTML = html;
    ensure(!template.content.querySelector('script,iframe,object'),'Invalid card content.');
    var cards = Array.from(template.content.querySelectorAll('.gc-cr-card')), keys = new Set();
    ensure(cards.length === batch.cardRows && cards.every(function (card) {
      var key = card.dataset.designKey;
      if (!key || keys.has(key)) return false; keys.add(key);
      if (state.model && card.dataset.gcInitialModel !== state.model) return false;
      if (state.model) {
        var price = Number(card.dataset.minPrice);
        if (!Number.isSafeInteger(price) || price < 0 || !card.dataset.minPrice) return false;
        return Array.from(card.querySelectorAll('a')).every(function (a) {
          var url = new URL(a.getAttribute('href'),window.location.origin);
          return url.origin === window.location.origin && /^\/products\/[^/]+$/.test(url.pathname) && /^\d+$/.test(url.searchParams.get('variant') || '') && url.searchParams.get('model') === state.model;
        });
      }
      return !card.dataset.minPrice && card.querySelector('.gc-cr-card__price')?.hidden;
    }),'Unverified family card.');
    return cards;
  };
  Redesign.prototype.fetchBatch = async function (page, state, controller) {
    var url = new URL(this.cfg.pageEndpoint || '/search',window.location.origin), current = new URL(window.location.href);
    url.search = ''; url.searchParams.set('page',String(page));
    if (this.cfg.collectionHandle === 'all') {
      // Native collection pagination applies the sort globally before pagination.
      // Tag OR supplies a superset; each rendered card still proves case AND style.
      url.searchParams.set('view','gc-paged');
      url.searchParams.set('sort_by',state.sort);
      if (state.model) url.searchParams.set(this.cfg.sizeParam,state.model);
      if (state.caseKey) url.searchParams.append('filter.p.tag','case-'+state.caseKey);
      state.styles.forEach(function (style) { url.searchParams.append('filter.p.tag','style-'+style); });
    } else {
      url.searchParams.set('view','gc-collection-page');
      url.searchParams.set('q',['gc-page-v1',this.cfg.collectionHandle,state.model || '-',state.caseKey || '-',state.styles.join(',') || '-'].join('|'));
    }
    ['preview_theme_id','_fd','pb'].forEach(function (key) { if (current.searchParams.has(key)) url.searchParams.set(key,current.searchParams.get(key)); });
    var timer;
    try {
      return await Promise.race([
        (async function () { var response = await fetch(url.pathname+url.search,{credentials:'same-origin',signal:controller.signal}); if (!response.ok) throw new Error('Page unavailable.'); return response.json(); })(),
        new Promise(function (_,reject) { timer = setTimeout(function () { controller.abort(); reject(new Error('Page timed out.')); },12000); })
      ]);
    } finally { clearTimeout(timer); }
  };
  Redesign.prototype.preparePreview = function () {
    var me = this;
    this.els.grid.querySelectorAll('.gc-cr-card').forEach(function (card) {
      var title = card.querySelector('.gc-cr-card__title a');
      var target = card.dataset.gcGenericUrl || (title ? new URL(title.href,window.location.origin).pathname : '');
      card.querySelectorAll('.gc-cr-card__options').forEach(function (n) { n.remove(); });
      card.querySelectorAll('a').forEach(function (a) { if (target) a.setAttribute('href',target); });
      var price = card.querySelector('.gc-cr-card__price'); if (price) { price.hidden = true; price.textContent = ''; }
      var meta = card.querySelector('.gc-cr-card__meta'); if (meta) meta.textContent = me.state.model ? 'Design preview · checking your selection' : 'Design preview · choose your phone';
      var action = card.querySelector('.gc-cr-card__choose');
      if (action) { var link = document.createElement('a'); link.className = 'gc-cr-card__choose gc-cr-card__view'; link.href = target; link.textContent = 'View design'; action.replaceWith(link); }
      card.removeAttribute('data-min-price'); card.removeAttribute('data-case-count'); card.dataset.gcInitialModel = ''; card.classList.remove('is-choosing');
    });
    this.root.removeAttribute('data-gc-cr-initial-pending');
  };
  // Scan only empty/duplicate-only batches; preserve normal pagination once a new card is found.
  Redesign.prototype.acceptUntilMatch = async function (batch,cards,append,hydrate,state,controller,token) {
    for (;;) {
      if (this.loadToken !== token || controller.signal.aborted) return;
      var added = this.acceptBatch(batch,cards,append,hydrate);
      var scan = added === 0 && batch.nextPage !== null;
      var prove = this.seenDesigns.size === 0 && batch.page === 1;
      if (!scan && !prove) return;
      this.setLoading(true); this.els.empty.hidden = true;
      if (prove) await this.checkUnsupportedCase(batch);
      if (this.loadToken !== token || controller.signal.aborted) return;
      if (this.unsupportedCase || !scan) {
        this.setLoading(false);
        if (!this.unsupportedCase) this.els.empty.hidden = this.seenDesigns.size > 0;
        return;
      }
      this.els.moreStatus.textContent = 'Looking for matching designs…';
      var prior = batch, page = prior.nextPage;
      batch = await this.fetchBatch(page,state,controller);
      if (this.loadToken !== token || controller.signal.aborted) return;
      if (batch.scopeId !== prior.scopeId || batch.rawTotal !== prior.rawTotal || batch.pageSize !== prior.pageSize) throw new Error('This collection changed. Refresh the selection.');
      cards = this.validateBatch(batch,page,state,batch.html);
      append = true; hydrate = false;
    }
  };
  Redesign.prototype.load = async function () {
    this.closeChoosers(null);
    this.caseProofRequest?.abort(); this.unsupportedCase = false;
    var token = {}; this.loadToken = token; this.pageRequest?.abort();
    var state = this.requestState(), initial = this.initialPage; this.initialPage = null;
    this.pageData = null; this.seenDesigns = new Set(); this.els.more.hidden = true; this.els.empty.hidden = true;
    var initialCards = null;
    if (initial) {
      try { initialCards = this.validateBatch(initial,initial.page,state,this.els.grid.innerHTML); }
      catch (error) { initial = null; }
    }
    if (!initial) this.preparePreview();
    this.setLoading(true);
    this.els.count.textContent = this.els.grid.querySelector('.gc-cr-card') ? 'Design previews · updating your selection' : 'Loading this page…';
    this.renderActiveFilters();
    var controller = new AbortController(); this.pageRequest = controller;
    try {
      var batch = initial || await this.fetchBatch(1,state,controller);
      if (this.loadToken !== token || controller.signal.aborted) return;
      var cards = initial ? initialCards : this.validateBatch(batch,1,state,batch.html);
      await this.acceptUntilMatch(batch,cards,false,!!initial,state,controller,token);
    } catch (error) { if (this.loadToken === token) this.pageError(error,!!this.pageData); }
    finally { if (this.pageRequest === controller) this.pageRequest = null; }
  };
  Redesign.prototype.loadNext = async function () {
    if (this.loading || this.unsupportedCase || this.caseProofRequest || !this.pageData || this.pageData.nextPage === null) return;
    var token = this.loadToken, prior = this.pageData, page = prior.nextPage, state = this.requestState();
    this.setLoading(true); this.els.empty.hidden = true; this.els.moreStatus.textContent = 'Loading the next page…';
    var controller = new AbortController(); this.pageRequest = controller;
    try {
      var batch = await this.fetchBatch(page,state,controller);
      if (this.loadToken !== token || controller.signal.aborted) return;
      if (batch.scopeId !== prior.scopeId || batch.rawTotal !== prior.rawTotal || batch.pageSize !== prior.pageSize) throw new Error('This collection changed. Refresh the selection.');
      var cards = this.validateBatch(batch,page,state,batch.html);
      await this.acceptUntilMatch(batch,cards,true,false,state,controller,token);
    } catch (error) { if (this.loadToken === token) this.pageError(error,true); }
    finally { if (this.pageRequest === controller) this.pageRequest = null; }
  };
  Redesign.prototype.acceptBatch = function (batch,cards,append,hydrate) {
    var me = this;
    if (!append) this.seenDesigns = new Set();
    var added = cards.filter(function (card) { var key = card.dataset.designKey; if (me.seenDesigns.has(key)) return false; me.seenDesigns.add(key); return true; });
    if (!hydrate) {
      var fragment = document.createDocumentFragment(); added.forEach(function (card) { fragment.appendChild(card); });
      if (append) this.els.grid.appendChild(fragment); else this.els.grid.replaceChildren(fragment);
    }
    this.pageData = batch; this.setLoading(false);
    this.root.removeAttribute('data-gc-cr-initial-pending');
    this.root.setAttribute('data-gc-catalog-source',hydrate?'paged-ssr':'paged-ajax');
    var shown = this.seenDesigns.size;
    this.els.count.textContent = this.state.model ? '' : 'Choose your phone for exact prices.';
    this.els.more.hidden = batch.nextPage === null;
    this.els.moreStatus.textContent = batch.nextPage !== null ? (added.length ? 'More designs are available to load.' : 'No new matches in this batch. Load the next page or adjust your filters.') : 'You’ve reached the end of these pages.';
    this.els.empty.hidden = shown > 0;
    if (!shown) {
      var keepPhone = this.state.model ? ' · Keep phone' : '';
      var recovery = '';
      if (this.state.caseKey && !this.pageContext.lockedCase) recovery += '<button type="button" class="gc-cr__btn" data-gc-cr-action="clear-case">Try other case styles'+keepPhone+'</button> ';
      if ((this.state.caseKey && !this.pageContext.lockedCase) || this.state.styles.length) recovery += '<button type="button" class="gc-cr__btn gc-cr__btn--ghost" data-gc-cr-action="clear-all">Clear filters'+keepPhone+'</button>';
      else recovery += '<button type="button" class="gc-cr__btn gc-cr__btn--ghost" data-gc-cr-action="change-phone">Change phone</button>';
      this.els.empty.innerHTML = '<h2 class="gc-cr__empty-title">'+(batch.nextPage !== null ? 'No matches in this batch yet.' : 'No designs match this selection.')+'</h2>'+(batch.nextPage !== null ? '<p>More pages are available. Keep browsing, or adjust your selection below.</p>' : '')+'<div class="gc-cr__empty-actions">'+recovery+'</div>';
    }
    this.renderChips(); this.renderActiveFilters(); this.updateLowerModules();
    this.els.clear.hidden = !((this.state.caseKey && !this.pageContext.lockedCase) || this.state.styles.length);
    this.els.toolbar.hidden = !this.els.count.textContent && this.els.clear.hidden;
    return added.length;
  };
  Redesign.prototype.checkUnsupportedCase = async function (batch) {
    var locked = this.pageContext.lockedCase;
    if (!locked || !batch.model || !Array.isArray(batch.compatibleCases) || batch.compatibleCases.includes(locked)) return;
    var controller = new AbortController(), token = this.loadToken;
    this.caseProofRequest = controller; this.els.more.disabled = true;
    var previousStatus = this.els.moreStatus.textContent;
    this.els.moreStatus.textContent = 'Checking this case style for your phone…';
    var url = new URL(this.cfg.pageEndpoint || '/search',window.location.origin), current = new URL(window.location.href);
    url.search = ''; url.searchParams.set('view','gc-case-availability'); url.searchParams.set('page','1');
    url.searchParams.set('q',['gc-case-proof-v1',this.cfg.collectionHandle,batch.model].join('|'));
    ['preview_theme_id','_fd','pb'].forEach(function (key) { if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key)); });
    var timer = setTimeout(function(){controller.abort();},5000);
    try {
      var response = await fetch(url.href,{signal:controller.signal,credentials:'same-origin'});
      if(!response.ok) return;
      var proof = await response.json();
      if(this.loadToken !== token || this.pageData !== batch || controller.signal.aborted) return;
      if(proof.version !== 'gc-case-proof-1' || proof.complete !== true || proof.unsupported !== true || proof.collection !== batch.collection || proof.scopeId !== batch.scopeId || proof.model !== batch.model || proof.case !== locked || proof.rawTotal !== batch.rawTotal || proof.rows !== batch.rawTotal || !Number.isSafeInteger(proof.rows) || proof.rows < 0 || proof.rows > 250) return;
      this.unsupportedCase = true; this.els.more.hidden = true; this.els.moreStatus.textContent = '';
      var other = new URL(this.cfg.collectionPath,window.location.origin);
      other.pathname = other.pathname.replace(/\/collections\/[^/]+$/, '/collections/'+this.pageContext.brand+'-cases');
      other.searchParams.set('model',batch.model); other.searchParams.set(this.cfg.sizeParam,batch.model);
      if(this.state.styles.length){other.searchParams.set('style',this.state.styles.join(','));this.state.styles.forEach(function(style){other.searchParams.append('filter.p.tag','style-'+style);});}
      ['preview_theme_id','_fd','pb'].forEach(function(key){if(current.searchParams.has(key))other.searchParams.set(key,current.searchParams.get(key));});
      this.updateLowerModules();
      this.els.empty.hidden = false;
      this.els.empty.innerHTML = '<h2 class="gc-cr__empty-title">'+esc(this.caseLabel[locked] || 'This case style')+' is not available for '+esc(batch.model)+' in this collection.</h2><div class="gc-cr__empty-actions"><button type="button" class="gc-cr__btn" data-gc-cr-action="change-phone">Change phone</button><a class="gc-cr__btn gc-cr__btn--ghost" href="'+esc(other.pathname+other.search)+'">View other case styles</a></div>';
    } catch(error) {
      // Unproven compatibility never stops ordinary raw-page browsing.
    } finally {
      clearTimeout(timer);
      if(this.caseProofRequest === controller) this.caseProofRequest = null;
      if(this.loadToken === token && this.pageData === batch && !this.unsupportedCase) {
        this.els.more.disabled = this.loading; this.els.moreStatus.textContent = previousStatus;
      }
    }
  };
  Redesign.prototype.pageError = function (error,append) {
    console.warn('[gc-cr]', error.message);
    this.setLoading(false); this.els.empty.hidden = false;
    this.els.count.textContent = 'The requested page could not be verified.';
    this.els.toolbar.hidden = false;
    this.els.empty.innerHTML = '<p>We couldn’t load '+(append?'the next page':'this selection')+'. Please try again.</p><button type="button" class="gc-cr__btn" data-gc-cr-action="'+(append?'retry-next':'retry')+'">Try again</button>';
    this.els.moreStatus.textContent = '';
  };
  Redesign.prototype.retryLoad = function () { return this.load(); };
  Redesign.prototype.render = function (append) { return append ? this.loadNext() : this.load(); };
  Redesign.prototype.renderChips = function () {
    var me = this, s = this.state;
    var chip = function (kind,value,label,on) { return '<button type="button" class="gc-cr__chip'+(on?' is-on':'')+'" data-gc-cr-chip="'+kind+'" data-value="'+esc(value)+'" aria-pressed="'+on+'">'+esc(label)+'</button>'; };
    var cases = this.cfg.caseTypes.filter(function (c) { return !me.pageData?.compatibleCases || me.pageData.compatibleCases.includes(c.key) || c.key===s.caseKey; });
    this.els.caseChips.innerHTML = chip('case','','All case types',!s.caseKey)+cases.map(function(c){return chip('case',c.key,c.label,c.key===s.caseKey);}).join('');
    this.els.caseChips.closest('.gc-cr__filter-row').hidden = !!this.pageContext.lockedCase;
    this.els.styleChips.innerHTML = chip('style','','All styles',!s.styles.length)+this.cfg.styles.map(function(c){return chip('style',c.tag,c.label,s.styles.includes(c.tag));}).join('');
    [this.els.caseChips,this.els.styleChips].forEach(function(row){var selected=row.querySelector('.is-on[data-value]:not([data-value=""])');if(!selected)return;var a=row.getBoundingClientRect(),b=selected.getBoundingClientRect();if(b.left<a.left)row.scrollLeft+=b.left-a.left;else if(b.right>a.right)row.scrollLeft+=b.right-a.right;});
  };
  Redesign.prototype.renderActiveFilters = function () {
    var me = this, items = [];
    if (this.state.caseKey && !this.pageContext.lockedCase) items.push(['case',this.state.caseKey,this.caseLabel[this.state.caseKey]]);
    this.state.styles.forEach(function (v) { items.push(['style',v,me.styleLabel[v]]); });
    this.els.activeFilters.hidden = !items.length;
    this.els.activeFilters.innerHTML = items.map(function (x) {
      return '<button type="button" data-gc-cr-remove="' + x[0] + '" data-value="' + esc(x[1]) + '" aria-label="Remove ' + esc(x[2]) + ' filter">' + esc(x[2]) + ' <span aria-hidden="true">×</span></button>';
    }).join('');
  };

  Redesign.prototype.updateLowerModules = function (facets) {
    var me = this, allowed = this.pageData?.model === this.state.model && this.pageData?.compatibleCases ? new Set(this.pageData.compatibleCases) : null;
    this.root.querySelectorAll('[data-gc-guide-case]').forEach(function (card) {
      var key = card.dataset.gcGuideCase;
      card.hidden = !caseSupportsBrand(key, me.pageContext.brand) || (!!me.state.model && (!allowed || !allowed.has(key)));
      var u = new URL(window.location.href);
      u.pathname = me.cfg.collectionPath; u.searchParams.delete('page'); u.searchParams.delete('filter.p.tag');
      if (!me.pageContext.lockedCase) { u.searchParams.set('case', key); u.searchParams.append('filter.p.tag','case-'+key); }
      if (me.state.styles.length) { u.searchParams.set('style', me.state.styles.join(',')); me.state.styles.forEach(function(style){u.searchParams.append('filter.p.tag','style-'+style);}); }
      card.href = u.pathname + u.search;
    });
    this.root.querySelectorAll('.gc-collection-lower__section--guide').forEach(function(guide){
      guide.hidden = !!me.unsupportedCase && !guide.querySelector('[data-gc-guide-case]:not([hidden])');
    });
    this.root.querySelectorAll('[data-gc-custom-base-url]').forEach(function (link) {
      var u = new URL(link.dataset.gcCustomBaseUrl, window.location.origin);
      if (me.state.model) { u.searchParams.set('model', me.state.model); u.searchParams.set('device', brandOf(me.state.model)); }
      link.href = u.pathname + u.search;
    });
  };

  function init() {
    document.querySelectorAll('[data-gc-cr]').forEach(function (root) {
      if (root.__gcCr) return;
      try { root.__gcCr = new Redesign(root); } catch (e) { if (window.console) console.error('[gc-cr]', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

